export const routeMatches = (pathname: string, ...routes: string[]) => {
  const current = pathname.toLowerCase();
  return routes.some(route => {
    const target = route.toLowerCase();
    return current === target || current.startsWith(`${target}/`);
  });
};
